export default "__VITE_ASSET__BHQ0bQc9__"